import { ComponentProps, FC } from 'react'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import type { CRMIntegrationType } from '../integrations'
import classes from '../index.module.css'

type LegacyIntegrationItem = {
  key: CRMIntegrationType
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  is_active: boolean
  color: string
}

type LegacyWazzupIntegrationIconsProps = {
  integrations: LegacyIntegrationItem[]
  tooltipProps?: ComponentProps<typeof TooltipWrapper>
  onOpen: (key: CRMIntegrationType) => void
}

const LegacyWazzupIntegrationIcons: FC<LegacyWazzupIntegrationIconsProps> = ({
  integrations,
  tooltipProps,
  onOpen,
}) => (
  <>
    {integrations.map(({ key, icon: Icon, is_active, color }) => (
      <TooltipWrapper
        key={key}
        title={!is_active ? 'Интеграция ещё не подключена' : null}
        {...tooltipProps}
      >
        <div
          className={classes.linkWrapper}
          style={{ cursor: is_active ? 'pointer' : 'default' }}
          onClick={() => {
            if (!is_active) return
            onOpen(key)
          }}
        >
          <Icon
            style={{
              fill: is_active
                ? color
                : 'var(--color-button-icon-disabled-soft)',
            }}
          />
        </div>
      </TooltipWrapper>
    ))}
  </>
)

export default LegacyWazzupIntegrationIcons
